import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, CheckCircle, Star, TrendingUp } from 'lucide-react';

const WhyNeedSection = ({ onOpenContactForm }) => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-gray-900 to-[#1a1a2e] overflow-hidden">
      {/* Diagonal Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF9900]/10 to-transparent" style={{ clipPath: 'polygon(0 15%, 100% 0, 100% 85%, 0 100%)' }}></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-stretch">
          {/* Image on Left - Full Height with Curved Border */}
          <div className="order-2 lg:order-1">
            <div className="relative h-full group">
              <div className="absolute inset-0 bg-gradient-to-r from-[#FF9900] to-orange-600 rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
              <img
                src="/section1.png"
                alt="Why need trademark registration"
                className="relative w-full h-full object-cover rounded-3xl shadow-2xl border-2 border-white/10"
              />
            </div>
          </div>

          {/* Content on Right - Enhanced with More Elements */}
          <div className="order-1 lg:order-2 space-y-6 flex flex-col justify-between">
            <div>
              <div className="inline-block bg-gradient-to-r from-[#FF9900]/20 to-orange-600/20 border border-[#FF9900]/30 text-[#FF9900] px-4 py-2 rounded-full text-sm font-semibold mb-4">
                Essential Protection
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                Why US Trademark Registration is Essential for Your Business
              </h2>

              <p className="text-lg text-gray-300 leading-relaxed mb-4">
                US trademark registration provides federal trademark protection for your brand name, logo, and business identity. Online trademark filing with USPTO ensures your intellectual property remains secure nationwide. Without trademark registration services, your brand remains vulnerable to copycats and unauthorized trademark use by competitors.
              </p>

              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                For Amazon sellers and e-commerce businesses, federal trademark registration is mandatory for Amazon Brand Registry enrollment. Register brand on Amazon to unlock enhanced marketing tools, A+ Content, sponsored brand advertising, and comprehensive Amazon IP protection services.
              </p>

              {/* Key Benefits Grid */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <Shield className="w-8 h-8 text-[#FF9900] mb-2" />
                  <h4 className="text-white font-bold mb-1">Legal Protection</h4>
                  <p className="text-gray-400 text-sm">Exclusive nationwide rights</p>
                </div>
                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <CheckCircle className="w-8 h-8 text-[#FF9900] mb-2" />
                  <h4 className="text-white font-bold mb-1">Brand Credibility</h4>
                  <p className="text-gray-400 text-sm">Use the ® symbol</p>
                </div>
                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <Star className="w-8 h-8 text-[#FF9900] mb-2" />
                  <h4 className="text-white font-bold mb-1">Amazon Access</h4>
                  <p className="text-gray-400 text-sm">Brand Registry eligible</p>
                </div>
                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <TrendingUp className="w-8 h-8 text-[#FF9900] mb-2" />
                  <h4 className="text-white font-bold mb-1">Asset Value</h4>
                  <p className="text-gray-400 text-sm">Increases worth</p>
                </div>
              </div>

              <p className="text-gray-300 leading-relaxed mb-4">
                Professional trademark lawyer guidance ensures successful trademark application processing. Our trademark registration services include comprehensive trademark search, USPTO trademark filing, and trademark monitoring to protect your registered trademark from infringement. Register a trademark to increase business value, expand into new markets, and establish legal ownership of your brand identity.
              </p>

              {/* Additional Info Box */}
              <div className="bg-gradient-to-r from-[#FF9900]/20 to-orange-600/20 border border-[#FF9900]/30 rounded-xl p-4">
                <h4 className="text-[#FF9900] font-bold mb-2">Online Trademark Registration with Expert Support</h4>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Federal trademark registration provides exclusive nationwide brand protection rights. Our trademark attorneys handle complete USPTO trademark application filing, trademark search services, and trademark office filing to secure your brand. Register trademark online today with our affordable trademark registration services starting at $45.
                </p>
              </div>
            </div>

            <div>
              <Button
                onClick={onOpenContactForm}
                size="lg"
                className="bg-gradient-to-r from-[#FF9900] to-orange-600 hover:from-[#FF9900]/90 hover:to-orange-600/90 text-black px-8 py-6 text-lg mt-4 font-semibold shadow-lg"
              >
                Register My Trademark
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;